export default {
  title: 'КРУ. Планирование и учет педагогической нагрузки',
  name: 'Планирование и учет педагогической нагрузки - ИПР',

  menu: {
    admin: 'Админка',
    reports: 'Отчеты',
    main: 'Главная',
    config: 'Настройки',
    logout: 'Выход'
  },

  confirmation: {
    title: 'Внимание!',
    message: 'Подтвердите действие.',
    ok: 'OK',
    cancel: 'Отмена'
  },
  notification: {
    close: 'Закрыть'
  },

  contacts: {
    title: 'Контактные данные',
    message: 'Проверьте и укажите свои актуальные контактные данные:',
    ok: 'Сохранить',
    cancel: 'Закрыть',

    email: 'Электронная почта',
    phone: 'Домашний телефон',
    mobile: 'Сотовый телефон',
  }
}
